import React from 'react';

import { Box } from '@mui/material';

const filterStyles = {
  position: 'sticky',
  top: '0',
  backgroundColor: ({ palette }) => palette.background.primary,
  zIndex: 10,
};

const StickyHeader = ({ children }) => <Box sx={filterStyles}>{children}</Box>;

export default StickyHeader;
